export default {
  pageTitle: 'Fabrikasi Tower',
  metaDescription: 'TEF memfabrikasi distillation column dan process tower berbahan titanium, nickel alloy, dan stainless steel untuk aplikasi migas dan petrokimia.',
  sidebar: {
    title: 'Daftar Fabrikasi',
    vessel: 'Fabrikasi Vessel',
    heatExchanger: 'Fabrikasi Heat Exchanger',
    piping: 'Fabrikasi Piping',
    tower: 'Fabrikasi Tower',
    muffle: 'Fabrikasi Muffle',
    radiantTube: 'Fabrikasi Radiant Tube',
    otherEquipment: 'Fabrikasi Peralatan Lainnya',
  },
  fabricationOf: 'Fabrikasi',
  productName: 'Tower',
  description: 'Berikut adalah katalog pengalaman kami dalam fabrikasi Tower dengan berbagai jenis material, tipe, dan spesifikasi.',
};
